import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */

export const styles = {
  loading: { display: 'flex', justifyContent: 'center', marginTop: 2 },
  titleSection: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    paddingBottom: 1.25,
    paddingLeft: {
      xs: 3,
      sm: 4,
    },
    paddingTop: 3,
    overflow: 'unset',
  },
  dialogHeader: {
    paddingLeft: {
      xs: 2.5,
      sm: 3,
    },
  },
  thickDivider: {
    backgroundColor: 'gray.3',
    height: 8,
    border: 0,
    borderTop: (theme) => `1px solid ${theme.palette.gray[8]}`,
  },
  selectsSection: {
    flex: 'initial',
    padding: 0,

    overflow: 'hidden',
  },
  editorSection: {
    flex: '1 1 auto',
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 1.5,
    fill: (theme) => theme.palette.gray[56],
  },
  avatarWrapper: {
    marginRight: 2,
  },
  divider: {
    borderColor: 'gray.8',
  },
  contentWrapper: {
    padding: 0,
    height: '100vh',
    '.MuiTabs-root': {
      borderBottomColor: 'gray.12',
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      paddingLeft: 3.5,
    },
    '.MuiTabPanel-root': {
      padding: 0,
    },
  },
  noPadding: {
    padding: 4.5,
    '& .MuiAccordionDetails-root': {
      padding: 0,
    },
  },
  generalAlertsWrapper: {
    paddingTop: 0,
    paddingRight: 3,
    paddingLeft: 3,
  },
  generalAlertsWrapperInTabs: {
    paddingTop: 0,
    paddingRight: 3,
    paddingLeft: 3,
  },
}
